import { MeetingTemplatePreset } from '../../../store/ai/meetingTemplate'

export const MEETING_TEMPLATE_COLUMNS = ['A', 'B', 'C', 'D']

export const getMeetingTemplatePresetMetadata = (preset: MeetingTemplatePreset) => {
  try {
    return JSON.parse(preset.metadata) ?? {}
  } catch {}
  return {}
}
